// // material-ui
// import { useTheme } from '@mui/material/styles';

// // ==============================|| BONDED WAREHOUSE PORTAL LOGO SVG ||============================== //

// export default function LogoMain() {
//   const theme = useTheme();

//   return (
//     <svg width="160" height="36" viewBox="0 0 160 36" fill="none" xmlns="http://www.w3.org/2000/svg">
//       {/* Warehouse Roof */}
//       <path
//         d="M4 14L18 6L32 14V16H4V14Z"
//         fill={theme.vars.palette.primary.dark}
//       />

//       {/* Warehouse Body */}
//       <rect
//         x="6"
//         y="16"
//         width="24"
//         height="14"
//         rx="2"
//         fill={theme.vars.palette.primary.main}
//       />

//       {/* Shutter Lines */}
//       <rect x="9" y="19" width="18" height="2" fill="#ffffff50" />
//       <rect x="9" y="22" width="18" height="2" fill="#ffffff50" />
//       <rect x="9" y="25" width="18" height="2" fill="#ffffff50" />

//       {/* Bonded Lock */}
//       <rect
//         x="14"
//         y="26"
//         width="8"
//         height="6"
//         rx="1.5"
//         fill={theme.vars.palette.warning.main}
//       />
//       <path
//         d="M15.5 26V24.5C15.5 22.8 16.8 21.8 18 21.8C19.2 21.8 20.5 22.8 20.5 24.5V26"
//         stroke={theme.vars.palette.warning.dark}
//         strokeWidth="1.2"
//         fill="none"
//       />

//       {/* Text: Bonded */}
//       <text
//         x="40"
//         y="22"
//         fontSize="16"
//         fontWeight="700"
//         fill={theme.vars.palette.text.primary}
//         fontFamily='"Sofia Sans", sans-serif'
//       >
//         Bonded
//       </text>

//       {/* Text: Warehouse */}
//       <text
//         x="96"
//         y="22"
//         fontSize="13"
//         fontWeight="500"
//         fill={theme.vars.palette.text.secondary}
//         fontFamily='"Sofia Sans", sans-serif'
//       >
//         Warehouse
//       </text>
//     </svg>
//   );
// }

// material-ui
import { useTheme } from '@mui/material/styles';

// assets
import logoMain from '../../assets/images/users/TraceNode-Logo-01.jpg'; // Ya .svg, .jpg, .webp etc.

// ==============================|| BONDED WAREHOUSE PORTAL LOGO ||============================== //

export default function LogoMain() {
  const theme = useTheme();

  return (
    <img
      src={logoMain}
      alt="Bonded Warehouse Portal"
      style={{
        width: '180px',
        height: '200px',
        objectFit: 'cover'
      }}
    />
  );
}
